import axios from 'axios'

export const getCrossChecksHeppers = (params) => {
  return axios.get('helpers/cross-checks')
}

export const getShipmentHeppers = (params) => {
  let remoteUrl = '/helpers/shipments'

  return axios.get(remoteUrl, {params: params})
}



// WEBPACK FOOTER //
// ./src/api/helpers.js